//Additional Options and Benefits
import {getParentStructurePath} from '../../Common/PropertyPaths';

export const getOutPatientPhysicianTreatment = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);

  return {
    isPortabilityApplied: `${parentPath}.isPortabilityApplied`,
    isOutpatientPhysicianTreatmentsApplied: `${parentPath}.isOutpatientPhysicianTreatmentsApplied`,
    isHealthScreeningServicesRiderApplied: `${parentPath}.isHealthScreeningServicesRiderApplied`,
    //Out Patient Physician Treatment
    outpatientPhysicianTreatmentsDetails: {
      typeOfRider: `${parentPath}.outpatientPhysicianTreatmentsDetails.typeOfRider`,
      units: `${parentPath}.outpatientPhysicianTreatmentsDetails.units`,
      maxBenefitNumber: `${parentPath}.outpatientPhysicianTreatmentsDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.outpatientPhysicianTreatmentsDetails.timePeriodCd`,
      benefitAmount: `${parentPath}.outpatientPhysicianTreatmentsDetails.benefitAmount.amount`,
    },
  };
};

export const getHealthScreeningServices = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);

  return {
    isHealthScreeningServicesRiderApplied: `${parentPath}.isHealthScreeningServicesRiderApplied`,
    //Health Screening Services
    healthScreeningServicesRiderDetails: {
      healthScreeningType: `${parentPath}.healthScreeningServicesRiderDetails.healthScreeningType`,
      healthScreeningHashUnits: `${parentPath}.healthScreeningServicesRiderDetails.healthScreeningHashUnits`,
      timePeriodCd: `${parentPath}.healthScreeningServicesRiderDetails.timePeriodCd`,
      benefitAmount: `${parentPath}.healthScreeningServicesRiderDetails.benefitAmount.amount`,
      isPreventativeEnabled: `${parentPath}.healthScreeningServicesRiderDetails.isPreventativeEnabled`,
      options: `${parentPath}.healthScreeningServicesRiderDetails.options`,
    },
  };
};

export const getOrganizedSportsActivity = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);

  return {
    isOrganizedSportsActivityInjuryRiderApplied: `${parentPath}.isOrganizedSportsActivityInjuryRiderApplied`,
    organizedSportsActivityInjuryRiderDetails: {
      benefitPct: `${parentPath}.organizedSportsActivityInjuryRiderDetails.benefitPct`,
      isAccidentFacilityCareApplied: `${parentPath}.organizedSportsActivityInjuryRiderDetails.isAccidentFacilityCareApplied`,
      isAccidentInjuriesApplied: `${parentPath}.organizedSportsActivityInjuryRiderDetails.isAccidentInjuriesApplied`,
      isAccidentTreatmentUrgentCareApplied: `${parentPath}.organizedSportsActivityInjuryRiderDetails.isAccidentTreatmentUrgentCareApplied`,
      isTreatmentSupportRecoveryApplied: `${parentPath}.organizedSportsActivityInjuryRiderDetails.isTreatmentSupportRecoveryApplied`,
      isDislocationFractureRiderApplied: `${parentPath}.organizedSportsActivityInjuryRiderDetails.isDislocationFractureRiderApplied`,
    },
  };
};

export const deathandDismembermentPath = (planIndex: number, coverageIndex: number = 0, benefitName?: string) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);

  return {
    unitsOfAccidentalDeathAndDismemberment: `${parentPath}.unitsOfAccidentalDeathAndDismemberment`,
    isAccidentalDeathApplied: `${parentPath}.isAccidentalDeathApplied`,
    accidentalDeathDetails: {
      incurralPeriod: `${parentPath}.accidentalDeathDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.accidentalDeathDetails.benefitAmount.amount`,
    },
    isAccidentalDeathCommonCarrierApplied: `${parentPath}.isAccidentalDeathCommonCarrierApplied`,
    accidentalDeathCommonCarrierDetails: {
      incurralPeriod: `${parentPath}.accidentalDeathCommonCarrierDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.accidentalDeathCommonCarrierDetails.benefitAmount.amount`,
    },
    isAccidentalDismembermentApplied: `${parentPath}.isAccidentalDismembermentApplied`,
    //[0].coverageDefs[0].benefitStructure.accidentalDismembermentDetails
    accidentalDismembermentDetails: {
      incurralPeriod: `${parentPath}.accidentalDismembermentDetails.incurralPeriod`,
      bothArmsOrHandsLossAmount: `${parentPath}.accidentalDismembermentDetails.bothArmsOrHandsLossAmount.amount`,
      bothLegsOrFeetLossAmount: `${parentPath}.accidentalDismembermentDetails.bothLegsOrFeetLossAmount.amount`,
      oneHandOrArmAndOneLegOrFootLossAmount: `${parentPath}.accidentalDismembermentDetails.oneHandOrArmAndOneLegOrFootLossAmount.amount`,
      armOrHandLossAmount: `${parentPath}.accidentalDismembermentDetails.armOrHandLossAmount.amount`,
      legOrFootLossAmount: `${parentPath}.accidentalDismembermentDetails.legOrFootLossAmount.amount`,
      oneOrMoreFingersLossAmount: `${parentPath}.accidentalDismembermentDetails.oneOrMoreFingersLossAmount.amount`,
      oneOrMoreToesLossAmount: `${parentPath}.accidentalDismembermentDetails.oneOrMoreToesLossAmount.amount`,
      maximumBenefitAmount: `${parentPath}.accidentalDismembermentDetails.maximumBenefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.accidentalDismembermentDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.accidentalDismembermentDetails.timePeriodCd`,
    },
    isFunctionalLossApplied: `${parentPath}.isFunctionalLossApplied`,
    functionalLossDetails: {
      incurralPeriod: `${parentPath}.functionalLossDetails.incurralPeriod`,
      minimumDuration: `${parentPath}.functionalLossDetails.minimumDuration`,
      hearingLossAmount: `${parentPath}.functionalLossDetails.hearingLossAmount.amount`,
      sightLossAmount: `${parentPath}.functionalLossDetails.sightLossAmount.amount`,
      speechLossAmount: `${parentPath}.functionalLossDetails.speechLossAmount.amount`,
      maximumBenefitAmount: `${parentPath}.functionalLossDetails.maximumBenefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.functionalLossDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.functionalLossDetails.timePeriodCd`,
    },
    isAutomobileAccidentalDeathApplied: `${parentPath}.isAutomobileAccidentalDeathApplied`,
    automobileAccidentalDeathDetails: {
      incurralPeriod: `${parentPath}.automobileAccidentalDeathDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.automobileAccidentalDeathDetails.benefitAmount.amount`,
      details: `${parentPath}.automobileAccidentalDeathDetails`,
    },
  };
};

export const getAccidentDiagnosticPainPath = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);
  return {
    unitsOfDiagnosticPainManagement: `${parentPath}.unitsOfDiagnosticPainManagement`,
    isMajorDiagnosticExamApplied: `${parentPath}.isMajorDiagnosticExamApplied`,
    majorDiagnosticBenefitAmt: `${parentPath}.majorDiagnosticBenefitAmt.amount`,
    majorDiagnosticExamDetails: {
      incurralPeriod: `${parentPath}.majorDiagnosticExamDetails.incurralPeriod`,
      cATCustomizeBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.cATCustomizeBenefitAmount`,
      cATBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.cATBenefitAmount.amount`,
      eEGCustomizeBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.eEGCustomizeBenefitAmount`,
      eEGBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.eEGBenefitAmount.amount`,
      mRICustomizeBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.mRICustomizeBenefitAmount`,
      mRIBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.mRIBenefitAmount.amount`,
      pETCustomizeBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.pETCustomizeBenefitAmount`,
      pETBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.pETBenefitAmount.amount`,
      ultrasoundCustomizeBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.ultrasoundCustomizeBenefitAmount`,
      ultrasoundBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.ultrasoundBenefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.majorDiagnosticExamDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.majorDiagnosticExamDetails.timePeriodCd`,
    },
    isPainManagementApplied: `${parentPath}.isPainManagementApplied`,
    painManagementDetails: {
      incurralPeriod: `${parentPath}.painManagementDetails.incurralPeriod`,
      benefitAmount: `${parentPath}.painManagementDetails.benefitAmount.amount`,
      epiduralInjection: `${parentPath}.painManagementDetails.epiduralInjection`,
      nerveAblationProcedure: `${parentPath}.painManagementDetails.nerveAblationProcedure`,
      maxBenefitNumber: `${parentPath}.painManagementDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.painManagementDetails.timePeriodCd`,
      details: `${parentPath}.painManagementDetails`,
    },
    isPainManagementCorticosteroidInjectionApplied: `${parentPath}.isPainManagementCorticosteroidInjectionApplied`,
    painManagementCorticosteroidInjectionBenefit: {
      incurralPeriod: `${parentPath}.painManagementCorticosteroidInjectionBenefit.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.painManagementCorticosteroidInjectionBenefit.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.painManagementCorticosteroidInjectionBenefit.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.painManagementCorticosteroidInjectionBenefit.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.painManagementCorticosteroidInjectionBenefit.timePeriodCd`,
      details: `${parentPath}.painManagementCorticosteroidInjectionBenefit`,
    },
  };
};

export const getEmergencyRoomServices = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);
  return {
    isEmergencyRoomServicesApplied: `${parentPath}.isEmergencyRoomServicesApplied`,
    emergencyRoomServicesDetails: {
      unitsOfEmergencyRoomServices: `${parentPath}.emergencyRoomServicesDetails.unitsOfEmergencyRoomServices`,
      incurralPeriod: `${parentPath}.emergencyRoomServicesDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.emergencyRoomServicesDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.emergencyRoomServicesDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.emergencyRoomServicesDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.emergencyRoomServicesDetails.timePeriodCd`,
      details: `${parentPath}.emergencyRoomServicesDetails`,
    },
  };
};

export const getAccidentXRayPath = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);

  return {
    isXRayApplied: `${parentPath}.isXRayApplied`,

    xRayDetails: {
      units: `${parentPath}.xRayDetails.units`,
      incurralPeriod: `${parentPath}.xRayDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.xRayDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.xRayDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.xRayDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.xRayDetails.timePeriodCd`,
      details: `${parentPath}.xRayDetails`,
    },
  };
};

export const accidentAmbulanceCarePath = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);

  return {
    unitsOfAccAmbulanceUrgentCare: `${parentPath}.unitsOfAccAmbulanceUrgentCare`,
    isAmbulanceAirApplied: `${parentPath}.isAmbulanceAirApplied`,
    isAmbulanceGroundOrWaterApplied: `${parentPath}.isAmbulanceGroundOrWaterApplied`,
    isUrgentCareApplied: `${parentPath}.isUrgentCareApplied`,
    isAccidentPhysicianTreatmentApplied: `${parentPath}.isAccidentPhysicianTreatmentApplied`,

    ambulanceUrgentCareBenefit: {
      incurralPeriod: `${parentPath}.ambulanceUrgentCareBenefit.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.ambulanceUrgentCareBenefit.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.ambulanceUrgentCareBenefit.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.ambulanceUrgentCareBenefit.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.ambulanceUrgentCareBenefit.timePeriodCd`,
    },

    ambulanceAirDetails: {
      incurralPeriod: `${parentPath}.ambulanceAirDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.ambulanceAirDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.ambulanceAirDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.ambulanceAirDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.ambulanceAirDetails.timePeriodCd`,
    },

    ambulanceGroundOrWaterDetails: {
      incurralPeriod: `${parentPath}.ambulanceGroundOrWaterDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.ambulanceGroundOrWaterDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.ambulanceGroundOrWaterDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.ambulanceGroundOrWaterDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.ambulanceGroundOrWaterDetails.timePeriodCd`,
    },

    urgentCareDetails: {
      incurralPeriod: `${parentPath}.urgentCareDetails.incurralPeriod`,
      customizeBenefitAmount: `${parentPath}.urgentCareDetails.customizeBenefitAmount`,
      benefitAmount: `${parentPath}.urgentCareDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.urgentCareDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.urgentCareDetails.timePeriodCd`,
    },
  };
};

export const accidentFollowupTreatmentPath = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);

  return {
    isFollowUpTreatmentApplied: `${parentPath}.isFollowUpTreatmentApplied`,

    followUpTreatmentDetails: {
      units: `${parentPath}.followUpTreatmentDetails.units`,
      incurralPeriod: `${parentPath}.followUpTreatmentDetails.incurralPeriod`,
      isBenefitAmountCustomize: `${parentPath}.followUpTreatmentDetails.isBenefitAmountCustomize`,
      benefitAmount: `${parentPath}.followUpTreatmentDetails.benefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.followUpTreatmentDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.followUpTreatmentDetails.timePeriodCd`,
      details: `${parentPath}.followUpTreatmentDetails`,
    },
  };
};

export const accidentBenefitsUpdateFields = (planIndex: number = 0, coverageIndex: number = 0) => {
  const parentPath = getParentStructurePath(planIndex, coverageIndex);

  return {
    unitsOfAccidentFacilityCare: `${parentPath}.unitsOfAccidentFacilityCare`,
    unitsOfAccidentInjuries: `${parentPath}.unitsOfAccidentInjuries`,
    followUpTreatmentDetails: {
      units: `${parentPath}.followUpTreatmentDetails.units`,
    },
    unitsOfAccAmbulanceUrgentCare: `${parentPath}.unitsOfAccAmbulanceUrgentCare`,
    xRayDetails: {
      units: `${parentPath}.xRayDetails.units`,
      benefitAmount: `${parentPath}.xRayDetails.benefitAmount.amount`,
    },
    unitsOfEmergencyRoomServices: `${parentPath}.emergencyRoomServicesDetails.unitsOfEmergencyRoomServices`,
    unitsOfAccAccidentSurgeries: `${parentPath}.unitsOfAccAccidentSurgeries`,
    unitsOfDiagnosticPainManagement: `${parentPath}.unitsOfDiagnosticPainManagement`,
    unitsOfTreatmentSupportAndRecovery: `${parentPath}.unitsOfTreatmentSupportAndRecovery`,
    unitsOfAccidentalDeathAndDismemberment: `${parentPath}.unitsOfAccidentalDeathAndDismemberment`,
    unitsOfDislocationRider: `${parentPath}.unitsOfDislocationRider`,
    XRaybenefitAmount: `${parentPath}.xRayDetails.benefitAmount.amount`,
    brainInjuryDiagnosisDetailsBenefitAmount: `${parentPath}.brainInjuryDiagnosisDetails.benefitAmount.amount`,
    brokenToothDetailsBenefitAmount: `${parentPath}.brokenToothDetails.benefitAmount.amount`,
    comaDetailsBenefitAmount: `${parentPath}.comaDetails.benefitAmount.amount`,
    punctureWoundDetailsBenefitAmount: `${parentPath}.punctureWoundDetails.benefitAmount.amount`,
    gunshotWoundDetailsBenefitAmount: `${parentPath}.gunshotWoundDetails.benefitAmount.amount`,
    threeOrFourLimbsAmount: `${parentPath}.paralysisDetails.threeOrFourLimbsAmount.amount`,
    oneOrTwoLimbsAmount: `${parentPath}.paralysisDetails.oneOrTwoLimbsAmount.amount`,
    withoutRepairAmount: `${parentPath}.lacerationDetails.withoutRepairAmount.amount`,
    withRepairAmount: `${parentPath}.lacerationDetails.withRepairAmount.amount`,
    lacerationLength1Amount: `${parentPath}.lacerationDetails.lacerationLength1Amount.amount`,
    lacerationLength2Amount: `${parentPath}.lacerationDetails.lacerationLength2Amount.amount`,
    lacerationLength3Amount: `${parentPath}.lacerationDetails.lacerationLength3Amount.amount`,
    lacerationBenefitAmount: `${parentPath}.lacerationDetails.benefitAmount.amount`,
    burnDegreeDetails: [
      //second degree burn
      {
        burnSize1Amount: `${parentPath}.burnDetails.burnDegreeDetails[0].burnSize1Amount.amount`,
        burnSize2Amount: `${parentPath}.burnDetails.burnDegreeDetails[0].burnSize2Amount.amount`,
        burnSize3Amount: `${parentPath}.burnDetails.burnDegreeDetails[0].burnSize3Amount.amount`,
      },
      //third degree burn
      {
        burnSize1Amount: `${parentPath}.burnDetails.burnDegreeDetails[1].burnSize1Amount.amount`,
        burnSize2Amount: `${parentPath}.burnDetails.burnDegreeDetails[1].burnSize2Amount.amount`,
        burnSize3Amount: `${parentPath}.burnDetails.burnDegreeDetails[1].burnSize3Amount.amount`,
      },
    ],
    rehabilitationFacilityBenefitAmount: `${parentPath}.rehabilitationFacilityDetails.benefitAmount.amount`,
    followUpTreatmentDetailsBenefitAmount: `${parentPath}.followUpTreatmentDetails.benefitAmount.amount`,
    ambulanceUrgentCareBenefitBenefitAmount: `${parentPath}.ambulanceUrgentCareBenefit.benefitAmount.amount`,
    ambulanceAirDetailsBenefitAmount: `${parentPath}.ambulanceAirDetails.benefitAmount.amount`,
    ambulanceGroundOrWaterDetailsBenefitAmount: `${parentPath}.ambulanceGroundOrWaterDetails.benefitAmount.amount`,
    urgentCareDetailsBenefitAmount: `${parentPath}.urgentCareDetails.benefitAmount.amount`,
    emergencyRoomServicesDetailsBenefitAmount: `${parentPath}.emergencyRoomServicesDetails.benefitAmount.amount`,
    companionNonLocalLodgingDetailsBenefitAmount: `${parentPath}.companionNonLocalLodgingDetails.benefitAmount.amount`,
    medicalEquipmentDetailsBenefitAmount: `${parentPath}.medicalEquipmentDetails.benefitAmount.amount`,
    medicalSuppliesDetailsBenefitAmount: `${parentPath}.medicalSuppliesDetails.benefitAmount.amount`,
    medicationDetailsBenefitAmount: `${parentPath}.medicationDetails.benefitAmount.amount`,
    nonLocalTransportationDetailsBenefitAmount: `${parentPath}.nonLocalTransportationDetails.benefitAmount.amount`,
    postAccidentCommonCarrierTransportationDetailsBenefitAmount: `${parentPath}.postAccidentCommonCarrierTransportationDetails.benefitAmount.amount`,
    oneDeviceAmount: `${parentPath}.prosthesisDetails.oneDeviceAmount.amount`,
    twoOrMoreDevicesAmount: `${parentPath}.prosthesisDetails.twoOrMoreDevicesAmount.amount`,
    residenceAutomobileModificationDetailsBenefitAmount: `${parentPath}.residenceAutomobileModificationDetails.benefitAmount.amount`,
    therapyDetailsBenefitAmount: `${parentPath}.therapyDetails.benefitAmount.amount`,
    accidentalDeathDetailsBenefitAmount: `${parentPath}.accidentalDeathDetails.benefitAmount.amount`,
    accidentalDeathCommonCarrierDetailsBenefitAmount: `${parentPath}.accidentalDeathCommonCarrierDetails.benefitAmount.amount`,
    bothArmsOrHandsLossAmount: `${parentPath}.accidentalDismembermentDetails.bothArmsOrHandsLossAmount.amount`,
    bothLegsOrFeetLossAmount: `${parentPath}.accidentalDismembermentDetails.bothLegsOrFeetLossAmount.amount`,
    oneHandOrArmAndOneLegOrFootLossAmount: `${parentPath}.accidentalDismembermentDetails.oneHandOrArmAndOneLegOrFootLossAmount.amount`,
    armOrHandLossAmount: `${parentPath}.accidentalDismembermentDetails.armOrHandLossAmount.amount`,
    legOrFootLossAmount: `${parentPath}.accidentalDismembermentDetails.legOrFootLossAmount.amount`,
    oneOrMoreFingersLossAmount: `${parentPath}.accidentalDismembermentDetails.oneOrMoreFingersLossAmount.amount`,
    oneOrMoreToesLossAmount: `${parentPath}.accidentalDismembermentDetails.oneOrMoreToesLossAmount.amount`,
    maximumBenefitAmount: `${parentPath}.accidentalDismembermentDetails.maximumBenefitAmount.amount`,
    hearingLossAmount: `${parentPath}.functionalLossDetails.hearingLossAmount.amount`,
    sightLossAmount: `${parentPath}.functionalLossDetails.sightLossAmount.amount`,
    speechLossAmount: `${parentPath}.functionalLossDetails.speechLossAmount.amount`,
    functionalLossDetailsMaximumBenefitAmount: `${parentPath}.functionalLossDetails.maximumBenefitAmount.amount`,
    automobileAccidentalDeathDetailsBenefitAmount: `${parentPath}.automobileAccidentalDeathDetails.benefitAmount.amount`,
    maximumClosedReductionBenefitAmount: `${parentPath}.dislocationFractureRiderDetails.maximumClosedReductionBenefitAmount.amount`,
    maximumOpenReductionBenefitAmount: `${parentPath}.dislocationFractureRiderDetails.maximumOpenReductionBenefitAmount.amount`,
    reductionAmountDetails: Array.from({length: 2}, (_, index) => ({
      hipAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].hipAmount.amount`,
      kneeNoPatellaAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].kneeNoPatellaAmount.amount`,
      footBonesAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].footBonesAmount.amount`,
      ankleAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].ankleAmount.amount`,
      wristAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].wristAmount.amount`,
      elbowAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].elbowAmount.amount`,
      shoulderGlenohumeralAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].shoulderGlenohumeralAmount.amount`,
      handBonesAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].handBonesAmount.amount`,
      collarboneAcromioclavicularAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].collarboneAcromioclavicularAmount.amount`,
      twoOrMoreFingersAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].twoOrMoreFingersAmount.amount`,
      twoOrMoreToesAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].twoOrMoreToesAmount.amount`,
      oneFingerOrToeAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].oneFingerOrToeAmount.amount`,
      kneecapAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].kneecapAmount.amount`,
      lowerJawAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].lowerJawAmount.amount`,
      otherDislocationAmount: `${parentPath}.dislocationDetails.reductionAmountDetails[${index}].otherDislocationAmount.amount`,
    })),
    fractureDetailsReductionAmountDetails: [
      {
        hipAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].hipAmount.amount`,
        skullFractureNonDepressedNoFaceNoseBonesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].skullFractureNonDepressedNoFaceNoseBonesAmount.amount`,
        pelvisInclIliumIschiumPubisAcetabulumNoCoccyxAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].pelvisInclIliumIschiumPubisAcetabulumNoCoccyxAmount.amount`,
        upperArmBetwElbowAndShoulderHumerusAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].upperArmBetwElbowAndShoulderHumerusAmount.amount`,
        shoulderBladeScapulaAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].shoulderBladeScapulaAmount.amount`,
        legTibiaFibulaAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].legTibiaFibulaAmount.amount`,
        ankleAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].ankleAmount.amount`,
        kneecapPatellaAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].kneecapPatellaAmount.amount`,
        collarboneClavicleSternumAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].collarboneClavicleSternumAmount.amount`,
        forearmRadiusUlnaAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].forearmRadiusUlnaAmount.amount`,
        footOrHeelNoToesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].footOrHeelNoToesAmount.amount`,
        handNoFingersAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].handNoFingersAmount.amount`,
        lowerJawMandibleNoAlveolarProcessAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].lowerJawMandibleNoAlveolarProcessAmount.amount`,
        twoOrMoreRibsFingersOrToesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].twoOrMoreRibsFingersOrToesAmount.amount`,
        faceOrNoseBonesNoMandibleOrMaxillaAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].faceOrNoseBonesNoMandibleOrMaxillaAmount.amount`,
        noseAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].noseAmount.amount`,
        oneRibFingerOrToeAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].oneRibFingerOrToeAmount.amount`,
        coccyxAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].coccyxAmount.amount`,
        skullFractureDepressedNoFaceNoseBonesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].skullFractureDepressedNoFaceNoseBonesAmount.amount`,
        vertebraeBodyOfNoVertebralProcessesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].vertebraeBodyOfNoVertebralProcessesAmount.amount`,
        vertebralProcessesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].vertebralProcessesAmount.amount`,
        upperJawMaxillaNoAlveolarProcessAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].upperJawMaxillaNoAlveolarProcessAmount.amount`,
        sternumAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].sternumAmount.amount`,
        anyOtherFractureAmount: `${parentPath}.fractureDetails.reductionAmountDetails[0].anyOtherFractureAmount.amount`,
      },
      {
        hipAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].hipAmount.amount`,
        skullFractureNonDepressedNoFaceNoseBonesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].skullFractureNonDepressedNoFaceNoseBonesAmount.amount`,
        pelvisInclIliumIschiumPubisAcetabulumNoCoccyxAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].pelvisInclIliumIschiumPubisAcetabulumNoCoccyxAmount.amount`,
        upperArmBetwElbowAndShoulderHumerusAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].upperArmBetwElbowAndShoulderHumerusAmount.amount`,
        shoulderBladeScapulaAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].shoulderBladeScapulaAmount.amount`,
        legTibiaFibulaAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].legTibiaFibulaAmount.amount`,
        ankleAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].ankleAmount.amount`,
        kneecapPatellaAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].kneecapPatellaAmount.amount`,
        collarboneClavicleSternumAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].collarboneClavicleSternumAmount.amount`,
        forearmRadiusUlnaAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].forearmRadiusUlnaAmount.amount`,
        footOrHeelNoToesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].footOrHeelNoToesAmount.amount`,
        handNoFingersAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].handNoFingersAmount.amount`,
        lowerJawMandibleNoAlveolarProcessAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].lowerJawMandibleNoAlveolarProcessAmount.amount`,
        twoOrMoreRibsFingersOrToesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].twoOrMoreRibsFingersOrToesAmount.amount`,
        faceOrNoseBonesNoMandibleOrMaxillaAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].faceOrNoseBonesNoMandibleOrMaxillaAmount.amount`,
        noseAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].noseAmount.amount`,
        oneRibFingerOrToeAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].oneRibFingerOrToeAmount.amount`,
        coccyxAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].coccyxAmount.amount`,
        skullFractureDepressedNoFaceNoseBonesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].skullFractureDepressedNoFaceNoseBonesAmount.amount`,
        vertebraeBodyOfNoVertebralProcessesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].vertebraeBodyOfNoVertebralProcessesAmount.amount`,
        vertebralProcessesAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].vertebralProcessesAmount.amount`,
        upperJawMaxillaNoAlveolarProcessAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].upperJawMaxillaNoAlveolarProcessAmount.amount`,
        sternumAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].sternumAmount.amount`,
        anyOtherFractureAmount: `${parentPath}.fractureDetails.reductionAmountDetails[1].anyOtherFractureAmount.amount`,
      },
    ],
    majorDiagnosticExamDetails: {
      incurralPeriod: `${parentPath}.majorDiagnosticExamDetails.incurralPeriod`,
      cATCustomizeBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.cATCustomizeBenefitAmount`,
      cATBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.cATBenefitAmount.amount`,
      eEGCustomizeBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.eEGCustomizeBenefitAmount`,
      eEGBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.eEGBenefitAmount.amount`,
      mRICustomizeBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.mRICustomizeBenefitAmount`,
      mRIBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.mRIBenefitAmount.amount`,
      pETCustomizeBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.pETCustomizeBenefitAmount`,
      pETBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.pETBenefitAmount.amount`,
      ultrasoundCustomizeBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.ultrasoundCustomizeBenefitAmount`,
      ultrasoundBenefitAmount: `${parentPath}.majorDiagnosticExamDetails.ultrasoundBenefitAmount.amount`,
      maxBenefitNumber: `${parentPath}.majorDiagnosticExamDetails.maxBenefitNumber`,
      timePeriodCd: `${parentPath}.majorDiagnosticExamDetails.timePeriodCd`,
    },
    painManagementDetailsBenefitAmount: `${parentPath}.painManagementDetails.benefitAmount.amount`,
    painManagementCorticosteroidInjectionBenefitAmount: `${parentPath}.painManagementCorticosteroidInjectionBenefit.benefitAmount.amount`,
    miscellaneousOutpatientSurgeryDetailsBenefitAmount: `${parentPath}.miscellaneousOutpatientSurgeryDetails.benefitAmount.amount`,
    openAbdominalOrThoracicSurgeryDetailsBenefitAmount: `${parentPath}.openAbdominalOrThoracicSurgeryDetails.benefitAmount.amount`,
    tendonLigamentRotatorCuffDetailsWithoutRepairAmount: `${parentPath}.tendonLigamentRotatorCuffDetails.withoutRepairAmount.amount`,
    tendonLigamentRotatorCuffDetailsWithRepairAmount: `${parentPath}.tendonLigamentRotatorCuffDetails.withRepairAmount.amount`,
    generalAnesthesiaDetailsBenefitAmount: `${parentPath}.generalAnesthesiaDetails.benefitAmount.amount`,
    rupturedDiscDetailsBenefitAmount: `${parentPath}.rupturedDiscDetails.benefitAmount.amount`,
    bloodPlasmaPlateletsDetailsBenefitAmount: `${parentPath}.bloodPlasmaPlateletsDetails.benefitAmount.amount`,
    eyeInjuryDetailsBenefitAmount: `${parentPath}.eyeInjuryDetails.benefitAmount.amount`,
  };
};
